import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

const formatter = Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });

export default function ({ user }) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.bradfordFactor}
      params={[user]}
      defaultData={{ style: '', label: '', score: 0 }}
      render={(loading, data) => (
        loading ? (
          <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />
        ) : (
          <>
            <div className={`text-${data.style}`}>
              <strong>{formatter.format(data.score)}</strong>
              {' - '}
              {data.label}
            </div>
            <div className="text-muted small">{data.desc}</div>
          </>
        )
      )}
    />
  );
}
